import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";

import LandingPage from "./LandingPage";
import ScrollGallery from "./components/ScrollGallery";
import PaintingsPage from "./PaintingsPage";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/paintings" element={<PaintingsPage />} />
          <Route path="/exhibitions" element={<ScrollGallery />} />
          {/* Old URL, kept so existing links keep working */}
          <Route path="/scrollgallery" element={<Navigate to="/exhibitions" replace />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  </React.StrictMode>
);
